import React from 'react';
import { translate } from 'react-i18next';
import Form from '../form/Form';
import FieldGroup from '../field_group/FieldGroup';
import { requiredValidator } from '../field_group/validators';
import { getErrorValue, toMilli } from '../../utils/utility';

export class MaterialTransparentDetail extends React.Component {
  constructor(props) {
    super(props);
    this.formRef = undefined;
  }

  getMaterialData() {
    return this.formRef.getFormData();
  }

  render() {
    const {
      name,
      thickness,
      SHGC,
      transmittance,
      U,
      description,
      image,
    } = this.props.material;

    const { disabled, fieldErrors, t, ...otherAttr } = this.props;
    const customAttr = { disabled };
    return (
      <Form
        {...otherAttr}
        image={image}
        errorMessage={getErrorValue(fieldErrors, 'detail')}
        ref={ref => (this.formRef = ref)}
      >
        <FieldGroup
          id="material-transparent-name"
          field="name"
          type="text"
          label={t('name')}
          placeholder={t('transparent material name')}
          value={name}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'name')}
          {...customAttr}
        />
        <FieldGroup
          id="material-transparent-thickness"
          field="thickness"
          type="number"
          label={<span>{t('thickness')} ({t('unit_mm')})</span>}
          placeholder="0.005"
          value={thickness && toMilli(thickness)}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'thickness')}
          {...customAttr}
        />
        <FieldGroup
          id="material-transparent-shgc"
          field="SHGC"
          type="number"
          label={t("SHGC")}
          placeholder="0.005"
          value={SHGC}
          {...customAttr}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'SHGC')}
        />
        <FieldGroup
          id="material-transparent-solar-energy-transmittance"
          field="transmittance"
          type="number"
          label={t('visible transmittance')}
          placeholder="0.89"
          value={transmittance}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'transmittance')}
          {...customAttr}
        />
        <FieldGroup
          id="material-transparent-u-value"
          field="U"
          type="number"
          label={<span>{t('U-value')} ({t('W/sq_m')}{t('℃')})</span>}
          placeholder="5.67"
          value={U}
          {...customAttr}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'U')}
        />
        <FieldGroup
          id="material-transparent-description"
          field="description"
          componentClass="textarea"
          label={t('description')}
          value={description}
          {...customAttr}
        />
      </Form>
    );
  }
}

MaterialTransparentDetail.defaultProps = {
  material: {},
};

export default translate('translations', { withRef: true })(MaterialTransparentDetail);



// WEBPACK FOOTER //
// ./src/components/material_opaque/MaterialTransparentDetail.js